export class ResponseModel {

    constructor( ok = false, response = [] ){
        this.ok = ok;
        this.response = response;
    }

    fromJSON( json ){
        if( json ){
            this.ok = json.ok;
            this.response = json.response;
        }
    }

}